import React, { useState } from 'react';
import { formatMomentDate } from "../../../../../utils/dateHelper";
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getUserInitial } from '../../../../../utils/otherHelopers';
import { EditIcon, Delete02Icon, PlusIcon } from '../../../../../assets/icons';
import EducationModal from '../../../../../components/modals/UserProfile/EducationModal';
import DeletePopup from '../../../../../components/delete-popup';
import { addUserEducation, updateUserEducation, deleteUserEducation } from '../../../../../redux/slice/allUsersSlice';
import { useToast } from '../../../../../context/TostContext';
import { IconBtn } from '../../../../../components/commonButton/btns';

const Education = ({ userDetail }) => {
    const {id} = useParams();
    const dispatch = useDispatch();
    const toast = useToast();
    const [showModal, setShowModal] = useState(false);
    const [currentItem, setCurrentItem] = useState(null);
    const [showDeletePopup, setShowDeletePopup] = useState(false);
    const [itemToDelete, setItemToDelete] = useState(null);

    const { educationLoading } = useSelector((state) => state.allUsers);

    const handleUpsertEducation = (data) => {
        const action = currentItem
            ? updateUserEducation({ id: id, educationId: currentItem.id, data })
            : addUserEducation({ id: id, data });

        dispatch(action)
            .unwrap()
            .then(() => {
                toast.success(`Education ${currentItem ? "updated" : "added"} successfully`);
                setShowModal(false);
                setCurrentItem(null);
            })
            .catch((error) => {
                toast.error(error?.message || `Failed to ${currentItem ? "update" : "add"} education`);
            });
    };

    const handleDeleteEducation = () => {
        dispatch(deleteUserEducation({ id: id, educationId: itemToDelete }))
            .unwrap()
            .then(() => {
                toast.success("Education deleted successfully");
                setShowDeletePopup(false);
                setItemToDelete(null);
            })
            .catch((error) => {
                toast.error(error?.message || "Failed to delete education");
            });
    };

    return (
        <div className="position-relative h-100">
            <div className="d-flex align-items-center justify-content-between mb-4">
                <h6 className="fw-bold mb-0" style={{ fontSize: '18px' }}>Education</h6>
                <IconBtn size={32} icon={<PlusIcon size={16} />} className='rounded-circle' onClick={() => {
                    setCurrentItem(null);
                    setShowModal(true);
                }} />
            </div>
            {userDetail?.education?.length > 0 ? (
                <div className="d-flex flex-column gap-3">
                    {userDetail.education.map((edu, index) => (
                        <div key={index} className="p-3 border rounded-3 bg-light-subtle position-relative custom-card">
                            <div className="position-absolute top-0 end-0 p-2 d-flex gap-2">
                                <button
                                    className="post-action-btn edit-btn border bg-white"
                                    onClick={() => {
                                        setCurrentItem(edu);
                                        setShowModal(true);
                                    }}
                                >
                                    <EditIcon width={14} height={14} color="#007bff" />
                                </button>
                                <button
                                    className="post-action-btn delete-btn border bg-white"
                                    onClick={() => {
                                        setItemToDelete(edu.id);
                                        setShowDeletePopup(true);
                                    }}
                                >
                                    <Delete02Icon size={14} />
                                </button>
                            </div>
                            <div className="d-flex gap-3">
                                <div className="profile-icon rounded-circle bg-success-subtle text-success d-flex align-items-center justify-content-center fw-bold mt-1" style={{ width: "40px", height: "40px", flexShrink: 0 }}>
                                    {getUserInitial(edu.university || "?")}
                                </div>
                                <div className="flex-grow-1">
                                    <h6 className="mb-1 fw-bold text-dark">{edu.university || "-"}</h6>
                                    <p className="mb-1 text-muted small fw-semibold">{edu.degree || "-"}{edu.field_of_study ? ` • ${edu.field_of_study}` : ""}</p>
                                    <p className="mb-0 text-muted small" style={{ fontSize: '11px' }}>
                                        {edu.from_date ? formatMomentDate(edu.from_date, "MMM YYYY") : ""} - {edu.to_date ? formatMomentDate(edu.to_date, "MMM YYYY") : "Present"}
                                    </p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                <div className="text-center py-5 text-muted">
                    <p className="mb-0">No education history listed.</p>
                </div>
            )}

            <EducationModal
                isOpen={showModal}
                onClose={() => {
                    setShowModal(false);
                    setCurrentItem(null);
                }}
                onSubmit={handleUpsertEducation}
                education={currentItem}
                isLoading={educationLoading}
                title={currentItem ? "Edit Education" : "Add Education"}
                size="lg"
            />

            <DeletePopup
                show={showDeletePopup}
                onHide={() => {
                    setShowDeletePopup(false);
                    setItemToDelete(null);
                }}
                onConfirm={handleDeleteEducation}
                content="Are you sure you want to delete this education entry?"
                saveTitle="Delete"
                disabled={educationLoading}
            />
        </div>
    );
};

export default Education;
